import * as messagingTypes from './messagingTypes';
import cloneDeep from 'lodash.clonedeep';
import { MESSAGEBOX_TYPES, MESSAGEDETAIL_TYPES, MESSAGEORDER_TYPES, MESSAGEBOX_VIEWS } from 'src/constants/constants';
import unescape from 'lodash.unescape';

const initialState = {
  inbox: {
    meta: {
      pageNum: 0,
      messagesPerPage: 0,
      selectedIndex: 0,
    },
    filters: {
      sortDirection: MESSAGEORDER_TYPES.DESC,
    },
    messages: [],
  },
  draft: {
    meta: {
      pageNum: 0,
      messagesPerPage: 0,
      selectedIndex: 0,
    },
    filters: {
      sortDirection: MESSAGEORDER_TYPES.DESC,
    },
    messages: [],
  },
  sent: {
    meta: {
      pageNum: 0,
      messagesPerPage: 0,
      selectedIndex: 0,
    },
    filters: {
      sortDirection: MESSAGEORDER_TYPES.DESC,
    },
    messages: [],
  },
  countInbox: 0,
  countInboxUnread: null,
  countSent: 0,
  countDrafts: 0,
  selectedMenu: MESSAGEBOX_TYPES.INBOX,
  anchorModal: null,
  showFilterModal: false,
  showToastMessage: false,
  toastMessage: '',
  detailType: MESSAGEDETAIL_TYPES.VIEWMESSAGE,
  messageShown: {},
  currentView: MESSAGEBOX_VIEWS.LIST,
  engagements: [],
  composeDrawerState: {
    open: false,
  },
  composeToAddress: null,
  caseId: null,
  composeId: null,
  attachments: [],
  casesMessages: null,
  filters: {
    contacts: [],
  },
  isFilterLoaded: false,
  isMessageLoaded: false,
  refreshDashboardUnReadCount: false,
  casePill: null,
  pageNumber: 1,
};

const messagingReducer = (state = initialState, action) => {
  const selectedMenuState = state[state.selectedMenu];
  switch (action.type) {
    case messagingTypes.GET_MESSAGES_SUCCESS:
      let messages = cloneDeep(state[action.menu].messages);
      action.data.messages.forEach(message => {
        message.preview = unescape(message.preview);
        message.body = unescape(message.body);
      });

      if (action.insertFront) {
        messages = action.data.messages || [];
      } else {
        messages.push(...action.data.messages);
      }
      return {
        ...state,
        [action.menu]: { ...state[action.menu], messages: messages },
        countInbox: state.countInbox,
        countSent: state.countSent,
        countDrafts: state.countDrafts,
        isMessageLoaded: true,
        pageNumber: Math.floor((messages.length - 1) / action.data.pageSize) + 1,
      };

    case messagingTypes.EMPTY_INBOX_MESSAGES: {
      const { [state.selectedMenu]: messageType } = state;
      return {
        ...state,
        [state.selectedMenu]: {
          ...messageType,
          messages: [],
        },
      };
    }

    case messagingTypes.CLEAR_MESSAGES_AND_COUNTS: {
      const { inbox: inboxMessages } = state; // eslint-disable-line
      const { sent: sentMessages } = state; // eslint-disable-line
      const { draft: draftMessages } = state; // eslint-disable-line

      return {
        ...state,
        inbox: {
          ...inboxMessages,
          messages: [],
        },
        sent: {
          ...sentMessages,
          messages: [],
        },
        draft: {
          ...draftMessages,
          messages: [],
        },
        countInbox: 0,
        //countInboxUnread: 0,
        countSent: 0,
        countDrafts: 0,
        messageShown: {},
      };
    }

    case messagingTypes.REMOVE_MESSAGE_FROM_STATE:
      const messagesClone = cloneDeep(state[action.menu].messages);
      action.msgId.forEach(id => {
        messagesClone.forEach((obj, index) => {
          if (obj.id === id) {
            messagesClone.splice(index, 1);
          }
        });
      });

      return {
        ...state,
        [action.menu]: {
          ...state[action.menu],
          messages: messagesClone,
        },
      };

    case messagingTypes.GET_MESSAGE_DETAILS_SUCCESS: {
      const { [state.selectedMenu]: messageType } = state;
      const messages = state[state.selectedMenu].messages;
      let countInboxUnread = state.countInboxUnread;
      if (state.selectedMenu === MESSAGEBOX_TYPES.INBOX) {
        messages.forEach(msg => {
          if (msg.id === action.data.id && !msg.read) {
            msg.read = true;
            countInboxUnread = countInboxUnread && countInboxUnread > 0 ? countInboxUnread - 1 : countInboxUnread;
          }
        });
      }

      action.data.preview = unescape(action.data.preview);
      action.data.body = unescape(action.data.body);

      return {
        ...state,
        messageShown: action.data,
        [state.selectedMenu]: {
          ...messageType,
          meta: { ...messageType.meta, selectedIndex: action.data.id },
          messages,
        },
        countInboxUnread,
        refreshDashboardUnReadCount: true,
      };
    }

    case messagingTypes.SELECT_MENU:
      return { ...state, selectedMenu: action.data };
    case messagingTypes.SELECT_MESSAGE:
      const { [state.selectedMenu]: messageType } = state;
      return {
        ...state,
        [state.selectedMenu]: {
          ...messageType,
          meta: { ...messageType.meta, selectedIndex: action.id },
        },
      };
    case messagingTypes.SELECT_DETAIL_VIEW:
      return { ...state, detailType: action.data };
    case messagingTypes.GET_COUNTS_SUCCESS:
      return {
        ...state,
        countInbox: action.data.countInbox,
        countSent: action.data.countSent,
        countDrafts: action.data.countDrafts,
        countInboxUnread: action.data.countUnread,
      };
    case messagingTypes.APPLY_FILTERS_PENDING:
      return {
        ...state,
        [state.selectedMenu]: {
          ...selectedMenuState,
          messages: [],
          filters: { ...selectedMenuState.filters, ...action.payload },
        },
      };
    case messagingTypes.CLEAR_FILTERS_PENDING:
      return {
        ...state,
        [state.selectedMenu]: {
          ...selectedMenuState,
          filters: {
            engagement: null,
            priority: null,
            sortDirection: MESSAGEORDER_TYPES.DESC,
            dateFrom: null,
            dateTo: null,
          },
        },
      };
    case messagingTypes.SHOW_FILTER_MODAL:
      return {
        ...state,
        showFilterModal: action.status,
        anchorModal: action.anchorEl, // I leave this for future fix of the popover modal location
      };
    case messagingTypes.CHANGE_SORT_ORDER:
      return {
        ...state,
        [state.selectedMenu]: {
          ...selectedMenuState,
          messages: [],
          filters: {
            ...selectedMenuState.filters,
            sortDirection: action.sortDirection,
          },
        },
      };
    case messagingTypes.SENDMESSAGE_PENDING:
      return { ...state };
    case messagingTypes.SHOW_NOTIFICATION_SUCCESS:
      return { ...state, showToastMessage: true, toastMessage: action.data };
    case messagingTypes.HIDE_NOTIFICATION_SUCCESS:
      return { ...state, showToastMessage: false };
    case messagingTypes.SWITCH_VIEW:
      return { ...state, currentView: action.view };
    case messagingTypes.ENGAGEMENT_LOAD_SUCCESS:
      return { ...state, engagements: action.engagements };
    case messagingTypes.TOGGLE_COMPOSE_DRAWER:
      return { ...state, composeDrawerState: action.payload };
    case messagingTypes.SET_ATTACHMENTS: {
      const attachments = state.attachments.slice();
      attachments.push({ messageId: action.composeId, attachmentId: action.attachmentId });
      return { ...state, composeId: action.composeId, attachments };
    }
    case messagingTypes.GET_CASES_MESSAGES_SUCCESS:
      return { ...state, casesMessages: action.messages };
    case messagingTypes.RESET_MESSAGE_SHOWN:
      return {
        ...state,
        messageShown: {},
        [state.selectedMenu]: {
          ...selectedMenuState,
          meta: {
            ...selectedMenuState.meta,
            selectedIndex: 0,
          },
        },
      };
    case messagingTypes.RESET_ATTACHMENTS:
      return { ...state, composeId: null, attachments: [] };
    case messagingTypes.DELETE_ATTACHMENT: {
      const attachments = state.attachments.slice();
      attachments.splice(action.index, 1);
      return { ...state, attachments };
    }

    case messagingTypes.RESUME_DRAFT_MESSAGE:
      const caseId = action.caseId || null;

      return { ...state, composeToAddress: action.accountInfo, caseId };
    case messagingTypes.CLEAR_RESUME_DRAFT:
      return { ...state, composeToAddress: null };

    case messagingTypes.RESET_COMPOSE_ID:
      return { ...state, composeId: null };
    case messagingTypes.SET_COMPOSE_ID:
      return { ...state, composeId: action.data };
    case messagingTypes.RESET_FILTERS:
      return {
        ...state,
      };
    case messagingTypes.SET_FILTERS:
      let newState = {
        ...state,
        inbox: {
          ...state.inbox,
          messages: [],
          filters: action.filters,
        },
        draft: {
          ...state.draft,
          messages: [],
          filters: action.filters,
        },
        sent: {
          ...state.sent,
          messages: [],
          filters: action.filters,
        },
      };
      return newState;
    case messagingTypes.GET_FILTERS:
      return {
        ...state,
        filters: action.data,
        isFilterLoaded: true,
      };
    case messagingTypes.RESET_IS_FILTER_LOADING:
      return {
        ...state,
        isFilterLoaded: false,
      };
    case messagingTypes.RESET_MESSAGE_LOADING:
      return {
        ...state,
        isMessageLoaded: false,
      };
    case messagingTypes.RESET_FOLDERS:
      return {
        ...state,
        inbox: {
          ...state.inbox,
          meta: initialState.inbox.meta,
        },
        sent: {
          ...state.sent,
          meta: initialState.sent.meta,
        },
        draft: {
          ...state.draft,
          meta: initialState.draft.meta,
        },
      };
    case messagingTypes.RESET_MENU:
      return {
        ...state,
        selectedMenu: MESSAGEBOX_TYPES.INBOX,
      };
    case messagingTypes.RESET_REFRESH_DASHBOARD_UN_READ_COUNT:
      return {
        ...state,
        refreshDashboardUnReadCount: false,
      };
    case messagingTypes.GET_PILL_FILTER:
      return {
        ...state,
        casePill: action.payload,
      };
    default:
      return state;
  }
};

export { initialState };
export default messagingReducer;
